module.exports = __webpack_public_path__ + "img/GoodWoodBallPark.78713f48.png";